import {useCallback, useMemo} from 'react'
import {atom, useAtom} from 'jotai'

const showBasketOverlayAtom = atom<boolean>(false)

const useBasketOverlayState = () => {
    const [isBasketOverlayVisible, setIsBasketOverlayVisible] = useAtom(showBasketOverlayAtom)

    const showBasketOverlay = useCallback(() => {
        setIsBasketOverlayVisible(true)
    }, [setIsBasketOverlayVisible])

    const hideBasketOverlay = useCallback(() => {
        setIsBasketOverlayVisible(false)
    }, [setIsBasketOverlayVisible])

    return useMemo(
        () => ({
            isBasketOverlayVisible,
            showBasketOverlay,
            hideBasketOverlay,
        }),
        [isBasketOverlayVisible, showBasketOverlay, hideBasketOverlay]
    )
}

export default useBasketOverlayState
